import React, { memo } from "react";

import { useCardSize } from "helpers";
import { OverviewCardProps } from "../types";

/**
 * Omotač jedne kartice u pregledu. Mjeri vlastitu širinu i objavljuje je kroz
 * `data-size`, pa sadržaj kroz `group-data-[size=...]/dashcard` stisne tipografiju
 * kad je kartica uska — kartice u ugniježđenoj mreži znaju biti uske i na velikom ekranu.
 */
const OverviewCard: React.FC<OverviewCardProps> = (props: OverviewCardProps) => {
  const { children } = props;

  const { size, ref } = useCardSize<HTMLDivElement>();

  return (
    <div ref={ref} data-size={size} className="group/dashcard h-full w-full">
      {children}
    </div>
  );
};

export default memo(OverviewCard);
